
    <overlay *ngIf="isVisible$ | async" tabindex="-1">
      <p>Drop Files to Upload</p>
    </overlay>
  